// The pxToRem() function helps you to convert a px unit into a rem unit

function pxToRem(px: number, basePxNumber = 16) {
    return `${px / basePxNumber}rem`;
}

export default pxToRem;
